export default __webpack_public_path__ + "static/media/OGFoodie.31a28f75.webp";